import { render } from "./SupplierSectionGeneral.vue?vue&type=template&id=71feef27&scoped=true"
import script from "./SupplierSectionGeneral.vue?vue&type=script&lang=js"
export * from "./SupplierSectionGeneral.vue?vue&type=script&lang=js"

import "./SupplierSectionGeneral.vue?vue&type=style&index=0&id=71feef27&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71feef27"]])

export default __exports__